import React, { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Programs", href: "#programs" },
  { label: "Membership", href: "/membership", external: true },
  { label: "Houston", href: "#houston" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar({ scrolled }) {
  const [open, setOpen] = useState(false);
  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0A0A0A]/95 backdrop-blur-md" : "bg-transparent"
      } border-b border-zinc-900`}
      data-testid="main-navbar"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="logo-link">
          <img src="https://customer-assets.emergentagent.com/job_houston-training-hub/artifacts/5f1feyf5_1781429554579.png" alt="Gain Time Fitness" className="w-8 h-8 object-cover shrink-0" />
          <span className="font-display text-lg tracking-wider">GAIN TIME FITNESS</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-400 hover:text-white transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="/member/login"
            className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 hover:text-[#E5B43A] transition-colors border-l border-zinc-800 pl-6"
            data-testid="nav-member-login"
          >
            Member Log In
          </a>
          <a
            href="/admin/login"
            className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-500 hover:text-[#E5B43A] transition-colors"
            data-testid="nav-admin-link"
          >
            Admin
          </a>
          <a
            href="#contact"
            className="ml-2 inline-flex items-center bg-[#E5B43A] text-black font-bold uppercase tracking-widest px-5 py-3 text-xs hover:bg-white hover:text-[#0A0A0A] transition-colors duration-300"
            data-testid="nav-cta-start"
          >
            Start Training
          </a>
        </nav>

        <button
          className="md:hidden w-10 h-10 grid place-items-center border border-zinc-800"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-900 bg-[#0A0A0A]" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-2 text-sm font-bold tracking-[0.2em] uppercase text-zinc-300"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="/member/login"
              onClick={() => setOpen(false)}
              className="py-2 text-sm font-bold tracking-[0.2em] uppercase text-zinc-300"
              data-testid="mobile-nav-member-login"
            >
              Member Log In
            </a>
            <a
              href="/admin/login"
              onClick={() => setOpen(false)}
              className="py-2 text-sm font-bold tracking-[0.2em] uppercase text-zinc-500"
              data-testid="mobile-nav-admin"
            >
              Admin
            </a>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 bg-[#E5B43A] text-black font-bold uppercase tracking-widest px-5 py-3 text-xs text-center"
              data-testid="mobile-cta-start"
            >
              Start Training
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
